<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" :persistent="loading" max-width="600px">
      <v-form
        ref="form"
        v-model="isValid"
        lazy-validation
        @submit.prevent="submit"
        v-if="payment"
      >
        <v-card>
          <v-card-title>
            Pago
            {{
              payment.payment_method === paymentMethodCash
                ? "en efectivo"
                : "por Datáfono"
            }}
            de:
            {{ formatPrice(amountToPay(payment)) }}
          </v-card-title>
          <v-card-text style="font-size: large">
            <v-row class="d-flex align-center ma-1`">
              <v-col cols="5">Entregado por cliente :</v-col>
              <v-col cols="7">
                <v-text-field
                  v-if="payment.payment_method === paymentMethodCash"
                  :rules="validation.amount"
                  type="number"
                  :disabled="loading"
                  :loading="loading"
                  suffix="‎€"
                  v-model="payment.cash_payment.amount_paid"
                ></v-text-field>

                <v-text-field
                  v-if="payment.payment_method === paymentMethodDatafono"
                  :rules="validation.amount"
                  type="number"
                  :disabled="loading"
                  :loading="loading"
                  suffix="‎€"
                  v-model="payment.datafono_payment.amount_paid"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="payment.payment_method === paymentMethodCash">
              <span class="ml-3">Cambio: {{ change }}</span>
            </v-row>
            <br />
            <v-row>
              <span class="ml-3"> Email: {{ payment.email }} </span>
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex justify-center">
            <button
              :class="`checkout-button ${loading && 'disabled'}`"
              :style="[
                { 'border-radius': buttonBorderRadiusTheme },
                { color: colorsGeneralPrimary },
                { borderColor: colorsGeneralPrimary }
              ]"
              type="submit"
            >
              <span>Pagar</span>
            </button>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import { updatePayment } from "@/collections/payments";
import { firestoreTimestamp } from "@/firebaseConfig";
import moment from "moment";
import firebaseMixin from "@/mixins/firebase/firebaseMixin";
import paymentsMixin from "@/mixins/payment/paymentsMixin";
import { updateOrder } from "@/collections/orders";
import {
  ordersTotalByTableCollection,
  updateOrderTotalByTable
} from "@/collections/ordersTotalByTable";

export default {
  name: "payment-change-dialog",
  mixins: [firebaseMixin, paymentsMixin],
  data() {
    return {
      payment_on: null,
      loading: false,
      payment: null,
      orders: [],
      dialog: false,
      isValid: false,
      validation: {
        amount: [
          v => !!v || "Se requiere la cantidad",
          v =>
            (!!v && this.checkValidAmount(v)) || "Ingrese una cantidad válida"
        ]
      },
      ordersTotalByTable: []
    };
  },
  firestore() {
    return {
      ordersTotalByTable: ordersTotalByTableCollection
    };
  },
  computed: {
    change() {
      let change =
        this.payment.cash_payment.amount_paid -
        this.payment.cash_payment.amount_to_pay;
      if (change < 0) {
        change = 0;
      }
      return this.formatPrice(change);
    },
    total() {
      let total = 0;
      this.orders.forEach(item => {
        if (item.isMenuGroupProduct) {
          item.starters.forEach(starter => {
            total += parseFloat(starter.additional_charge) * item.quantity;
          });
          item.maincourse.forEach(main => {
            total += parseFloat(main.additional_charge) * item.quantity;
          });
          item.desserts.forEach(dessert => {
            total += parseFloat(dessert.additional_charge) * item.quantity;
          });
          item.drinks.forEach(drink => {
            total += parseFloat(drink.additional_charge) * item.quantity;
          });
        }
        total += item.quantity * item.price;
      });

      return total;
    },
    getInvitationTotalPrice() {
      let total = 0;
      this.orders.forEach(item => {
        if (item.selectOption === "invitation") {
          total +=
            item.removeQuantity * item.price +
            this.totalWithAdditionalCharge(item);
        }
      });
      return total;
    }
  },
  methods: {
    openDialog(orders, payment) {
      this.orders = orders;

      if (
        payment &&
        payment.selectedProducts &&
        payment.selectedProducts.length > 0
      ) {
        payment.selectedProducts = payment.selectedProducts.map(item => {
          if (item.metadata) {
            // eslint-disable-next-line no-unused-vars
            for (const [quantity, metadata] of Object.entries(item.metadata)) {
              if (item.metadata[quantity].isSelected === true) {
                item.metadata[quantity].isPaid = true;
              }
            }
          }
          return item;
        });
      }
      this.payment = payment;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    checkValidAmount(v) {
      return parseFloat(v) >= parseFloat(this.amountToPay(this.payment));
    },
    async submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;
      this.payment_on = moment().toDate();

      try {
        await this.savePayment();
        await this.saveOrderTotal();
        await this.updateOrders();
        if (this.payment && this.payment.receipt_is_sent) {
          await this.sendEmail();
        }

        this.closeDialog();
      } catch (error) {
        // eslint-disable-next-line
        this.setlogError(
          "save_payment/save_order_total/update_orders",
          "Obtained error message in submit()",
          error.stack,
          this.$options.name
        );
      } finally {
        this.loading = false;
      }
    },
    sendEmail() {
      let baseUrl = this.projectUrl;
      let color = this.colorsGeneralPrimary;

      this.loading = true;

      this.$api.admin.sendEmail({
        color: color,
        logo:
          this.settings && this.settings.icons ? this.settings.icons.logo : "",
        orders: JSON.stringify(this.orders),
        total: this.total - this.getInvitationTotalPrice,
        amountPaid: this.amountToPay(this.payment),
        to: this.payment.email,
        from: process.env.VUE_APP_PROJECT_NAME,
        config_smtp:
          this.settings && this.settings.config_smtp
            ? this.settings.config_smtp
            : null,
        date: this.dayFormat2(this.payment_on),
        time: this.formatTime2(this.payment_on),
        subject: `Recibo de su pago a ${this.projectName}`,
        footerUrls: [
          {
            text: "Cookies",
            url: `${baseUrl}/cookies`
          },
          {
            text: "Privacidad",
            url: `${baseUrl}/privacy`
          },
          {
            text: "Términos y condiciones",
            url: `${baseUrl}/terms`
          },
          {
            text: "by aiwanna pay",
            url: `https://www.aiwannapay.com/`
          }
        ],
        invoiceRequest: this.payment.invoiceRequest,
        company: this.payment.company,
        settings: this.settings,
        tableQR: this.payment.tableQR,
        number: this.payment.number,
        paymentMethod: this.payment.payment_method,
        curr_language: this.$i18n.locale,
        email_trans: {
          mesa: this.$t("email.mesa") || "Mesa",
          product: this.$t("email.product") || "Producto",
          quantity: this.$t("email.quantity") || "Cantidad",
          price: this.$t("email.price") || "Precio",
          total: this.$t("email.total") || "Total de la cuenta",
          totalPaid: this.$t("email.totalPaid") || "Total Pagado",
          baseTax: this.$t("email.baseTax") || "Base imponible",
          VAT: this.$t("email.VAT") || "IVA",
          paymentMethod: this.$t("email.paymentMethod") || "Forma de pago",
          pagado: this.$t("email.pagado") || "Pagado"
        }
      });
    },
    async updateOrders() {
      if (
        this.payment &&
        this.payment.selectedProducts &&
        this.payment.selectedProducts.length > 0
      ) {
        this.payment.selectedProducts.forEach(async item => {
          try {
            await updateOrder(item.id, {
              ...item,
              time: moment(item.time?.seconds * 1000).toDate()
            });
          } catch (error) {
            this.setlogError(
              "update_orders",
              "Obtained error message in updateOrders()",
              error.stack,
              this.$options.name
            );
          }
        });
      } else {
        this.orders.forEach(async item => {
          try {
            if (item.metadata) {
              // eslint-disable-next-line no-unused-vars
              for (const [quantity, metadata] of Object.entries(
                item.metadata
              )) {
                item.metadata[quantity].isPaid = true;
              }
            }
            await updateOrder(item.id, item);
          } catch (error) {
            this.setlogError(
              "update_orders",
              "Obtained error message in updateOrders()",
              error.stack,
              this.$options.name
            );
          }
        });
      }
    },
    async savePayment() {
      try {
        let z_closure_id = await this.getzClosureIdAndUpdateWithPaymentMethodGiven(
          this.payment.payment_method
        );
        let now = moment().format();
        let payment = {
          orders: this.orders,
          receipt_is_sent: true,
          amount_paid_by_user: this.amountToPay(this.payment),
          cash_payment: {
            amount_paid: this.payment.cash_payment.amount_paid,
            change: this.change
          },
          datafono_payment: {
            amount_paid: this.payment.datafono_payment.amount_paid
          },
          z_closure_id: z_closure_id,
          payment_on: this.payment_on,
          updated_on: now
        };

        // actual payment done
        await updatePayment(this.payment.id, payment);
      } catch (error) {
        this.setlogError(
          "get_zClosure_id_and_update_with_payment_method_given/update_payment",
          "Obtained error message in savePayment()",
          error.stack,
          this.$options.name
        );
      }
    },
    async saveOrderTotal() {
      try {
        let time = firestoreTimestamp.fromDate(new Date());
        let orderByTotal = this.ordersTotalByTable.find(
          x => x.id === this.payment.tableQR
        );
        let remaining =
          parseFloat(orderByTotal.remaining).toFixed(2) -
          this.amountToPay(this.payment);

        if (remaining <= 0) {
          remaining = 0;
        }

        this.$emit("setRemaing", remaining);

        await updateOrderTotalByTable(this.payment.tableQR, {
          remaining: parseFloat(remaining.toFixed(2)),
          time: time
        });
      } catch (error) {
        this.setlogError(
          "update_order_total_by_table",
          "Obtained error message in saveOrderTotal()",
          error.stack,
          this.$options.name
        );
      }
    }
  }
};
</script>

<style lang="scss">
.checkout-button {
  display: flex;
  align-items: center;
  padding: 5px 30px;
  background: #fff;
  border: 3px solid;
  // color: $primary;
  font-size: 16px;
  font-weight: bold;
  transition: 200ms ease-in-out;

  svg {
    margin-left: 10px;
    transition: 200ms ease-in-out;
  }

  &:hover {
    // background: $primary;
    color: #000;
    transition: 200ms ease-in-out;

    svg {
      fill: #000;
      transition: 200ms ease-in-out;
    }
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
}
</style>
